var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"media-asset",class:_vm.classes},[_c('div',{staticClass:"container"},_vm._l((_vm.assets),function(asset){return _c('asset',{key:asset.id,attrs:{"asset":asset}})}),1),_c('div',{staticClass:"legend"},[_c('wysiwyg',{attrs:{"html":_vm.section.legend}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }